"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RevJetTag = void 0;
const react_1 = __importStar(require("react"));
const banner_1 = require("./banner");
const tag_request_1 = require("../tag-request");
const responsive_banner_1 = require("./responsive-banner");
const session_1 = require("../session");
const use_jsonp_request_1 = require("../hooks/use-jsonp-request");
function RevJetTag({ className, tagProperties, onBeforeLoad, onError, onLoad, onTrackingEvent }) {
    const { _opts } = tagProperties;
    const deliveryMethod = (_opts === null || _opts === void 0 ? void 0 : _opts.delivery_method) || 'banner';
    const requestUrl = (0, react_1.useMemo)(() => (0, tag_request_1.buildTagRequestUrl)(tagProperties), [tagProperties]);
    const onTagLoad = (0, react_1.useCallback)((response) => {
        if (response.data) {
            (0, session_1.updateSessionData)(response.data);
        }
        if (onLoad) {
            onLoad();
        }
    }, [onLoad]);
    const tagResponse = (0, use_jsonp_request_1.useJsonpRequest)(requestUrl, onBeforeLoad, onError, onTagLoad);
    if (deliveryMethod === 'banner') {
        const isResponsive = _opts === null || _opts === void 0 ? void 0 : _opts.responsive;
        if (isResponsive) {
            return (react_1.default.createElement(responsive_banner_1.ResponsiveBanner, { response: tagResponse, properties: tagProperties, onTrackingEvent: onTrackingEvent }));
        }
        else {
            return react_1.default.createElement(banner_1.Banner, { response: tagResponse, properties: tagProperties, onTrackingEvent: onTrackingEvent });
        }
    }
    return react_1.default.createElement("div", { className: className });
}
exports.RevJetTag = RevJetTag;
//# sourceMappingURL=revjet-tag.js.map